import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_PACKS_LIST_SUCCESS:
      return [...action.packs];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/packs.js